<script lang="ts">
	import { t } from '$lib/i18n/translation';
	import { page } from '$app/stores';

	export let title: string | undefined = undefined;
	export let description: string | undefined = undefined;
	export let noindex: boolean = false;

	$: host = `${$page.url.protocol}//${$page.url.host}`;
</script>

<svelte:head>
	{#if title}
		<title>{$t(title)} | Tales of Landor</title>
	{:else}
		<title>Tales of Landor</title>
	{/if}

	{#if description}
		<meta name="description" content={$t(description)} />
		<meta property="og:description" content={$t(description)} />
	{/if}
	{#if noindex}
		<meta name="robots" content="noindex" />
	{/if}

	<meta property="og:type" content="website" />
	<meta property="og:image" content={`${host}/logo-squared.png`} />
</svelte:head>
